var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"elementRef",staticClass:"w-6 h-6 cursor-pointer rounded-full bg-orange-500 ",style:(_vm.isFocused ? _vm.focusedStyle : {})})}
var staticRenderFns = []

export { render, staticRenderFns }